import { render, staticRenderFns } from "./supplierList.vue?vue&type=template&id=148a6e3f&scoped=true"
import script from "./supplierList.vue?vue&type=script&lang=ts"
export * from "./supplierList.vue?vue&type=script&lang=ts"
import style0 from "./supplierList.vue?vue&type=style&index=0&id=148a6e3f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148a6e3f",
  null
  
)

export default component.exports